module.exports = {};



/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/library/modules/_iterators.js
 ** module id = 125
 ** module chunks = 0
 **/